module.exports = __webpack_public_path__ + "a253a182fe21812ea755c3500a63a67f.svg";